import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { signUp } from 'services/api/auth-api.service';
import { storage } from 'services/services';
import { StorageKey, NotificationType } from 'common/enums/enums';
import { openNotificationModal } from 'store/use-notification-modal-store';

interface NotificationModalOptions {
  title: string;
  type: NotificationType;
  description: string;
  onClose: () => void;
}

const showSuccessNotification = (navigate: (path: string) => void) => {
  const options: Omit<NotificationModalOptions, 'open'> = {
    title: 'Account created successfully',
    type: NotificationType.SUCCESS,
    description: 'You will be redirected to the sign-in page',
    onClose: () => {
      storage.removeItem(StorageKey.REGISTRATION_ID);
      navigate('/auth/sign-in');
    },
  };
  
  // @ts-ignore - The openNotificationModal function expects a slightly different type
  openNotificationModal(options);
};

export default function useSignUpInvitation(
  options?: Omit<UseMutationOptions<string, Error, any, unknown>, 'mutationFn'>,
) {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (data: any) => {
      // Call the signUp API but skip phone verification
      const response = await signUp({
        ...data,
        skipPhoneVerification: true, // This will be used to skip phone verification
      });
      
      // Store the registration ID in case it's needed
      storage.setItem(StorageKey.REGISTRATION_ID, response);
      return response;
    },
    onSuccess: (data, variables) => {
      // Show success modal which will handle the redirect
      showSuccessNotification(navigate);
    },
    ...options,
  });
}
